var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteGeneralLedger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20.259,
    viewBox: "0 0 20 20.259",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8850",
    "data-name": "Group 8850",
    transform: "translate(-0.195 0.064)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8504",
    "data-name": "Group 8504",
    transform: "translate(2.66 -0.064)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_327",
    "data-name": "Path 327",
    d: "M1726.03,4172.743h1.061a.909.909,0,1,0,0-1.818h-1.061a.909.909,0,1,0,0,1.818Z",
    transform: "translate(-1722.528 -4163.206)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    d: "M1744.325,4172.743h1.061a.909.909,0,1,0,0-1.818h-1.061a.909.909,0,0,0,0,1.818Z",
    transform: "translate(-1737.349 -4163.206)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    d: "M1762.62,4172.743h1.061a.909.909,0,1,0,0-1.818h-1.061a.909.909,0,1,0,0,1.818Z",
    transform: "translate(-1752.171 -4163.206)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    "data-name": "Path 330",
    d: "M1726.03,4187.35h1.061a.909.909,0,1,0,0-1.817h-1.061a.909.909,0,1,0,0,1.817Z",
    transform: "translate(-1722.528 -4175.04)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    "data-name": "Path 331",
    d: "M1744.325,4187.35h1.061a.909.909,0,1,0,0-1.817h-1.061a.909.909,0,0,0,0,1.817Z",
    transform: "translate(-1737.349 -4175.04)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_185",
    "data-name": "Rectangle 185",
    width: 2.879,
    height: 4.591,
    rx: 1.439,
    transform: "translate(9.54 10.493)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    d: "M1726.03,4201.956h1.061a.909.909,0,1,0,0-1.818h-1.061a.909.909,0,1,0,0,1.818Z",
    transform: "translate(-1722.528 -4186.872)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    "data-name": "Path 333",
    d: "M1744.325,4201.956h1.061a.909.909,0,1,0,0-1.818h-1.061a.909.909,0,0,0,0,1.818Z",
    transform: "translate(-1737.349 -4186.872)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    "data-name": "Path 334",
    d: "M1726.22,4132.007a1.735,1.735,0,0,0-1.731-1.735H1713.2a1.735,1.735,0,0,0-1.731,1.735v4.018c0,.005,0,.009,0,.014s0,.009,0,.014v10.023a2.4,2.4,0,0,0,2.4,2.4h9.96a2.4,2.4,0,0,0,2.4-2.4v-10.023s0-.009,0-.014,0-.008,0-.014Zm-13.122,1.109a.918.918,0,0,1,.918-.918h9.829a.918.918,0,0,1,.918.918v1.238a.917.917,0,0,1-.918.918h-9.829a.917.917,0,0,1-.918-.918Zm11.6,12.959a.879.879,0,0,1-.878.878h-9.96a.878.878,0,0,1-.877-.878v-9.264H1724.7Z",
    transform: "translate(-1711.467 -4130.272)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_186",
    "data-name": "Rectangle 186",
    width: 20,
    height: 20,
    transform: "translate(0.195 0.195)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteGeneralLedger);
export default __webpack_public_path__ + "static/media/white_general_ledger.7bfe834dffe57ec93f6c61cb88fe9f63.svg";
export { ForwardRef as ReactComponent };